<template>
  <div class="checklists__add-actions">
    <!-- action button -->
    <AppActionButton v-if="!isEditing" @click="openEditBox">
      {{ text }}
    </AppActionButton>
    <!-- edit box -->
    <EditBox
      reset
      v-if="isEditing"
      @edition-done="updateValues"
      @close-box="closeEditBox"
      placeholder="Título..."
      save-button-text="Añadir"
    >
      <!-- <ChecklistsChecklistItemType v-if="isItem" v-model="type" /> -->
    </EditBox>
  </div>
</template>

<script>
// Utilities
import ChecklistsMixin from '../mixins'
// Components
import AppActionButton from 'Ui/AppActionButton'
// import ChecklistsChecklistItemType from './ChecklistsChecklistItemType'

export default {
  name: 'ChecklistsAddAction',

  components: {
    AppActionButton,
    // ChecklistsChecklistItemType,
  },

  props: {
    isItem: {
      type: Boolean,
      default: false,
    },

    text: {
      type: String,
      default: 'Añadir',
    },

    keepEditBox: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [ChecklistsMixin],

  data() {
    return {
      type: 'client',
    }
  },

  methods: {
    updateValues(title) {
      const data = {
        title: title,
      }
      // if is item we added to the data
      this.isItem && ((data.type = this.type), (this.type = 'client'))
      // sending data
      this.$emit('added', data)
      if (!title.trim() || this.keepEditBox) return
      this.closeEditBox()
    },
  },
}
</script>

<style scoped></style>
